<template>
    <SOSlotBase :bg-grey="true">
        <template v-slot:title-bar>
            <SOTitleBar :page-title="pageSetting.title" :type="'close'" @back="back" />
        </template>
        <template v-slot:content>
            <div class="p-x-20 p-y-16">
                <SOInputRegular
                    :title="'Nama template'"
                    :autocomplete="'off'"
                    :value="nama"
                    :placeholder="'Nama template'"
                    :required="true"
                    @input="
                        (v) => {
                            nama = v;
                        }
                    "
                />
            </div>
            <div
                class="f-regular f-14 f-c-blue p-x-20 p-d-16"
                @click="$router.push({ name: 'wa_blast.template-pesan.create.panduan' })"
            >
                Lihat panduan penulisan
            </div>

            <div class="p-x-12 p-d-16">
                <SOInputWysiwyg :saving-update="saveTemplate" :category="'blast'" />
            </div>

            <!--            <div class="p-x-20 p-t-16 f-regular f-14 f-c-midgrey text-center">-->
            <!--                Terakhir diubah 12 Agu 2021 19:00-->
            <!--            </div>-->
        </template>
    </SOSlotBase>
</template>

<script>
import { moduleName } from "./../store/state";
import { mapGetters, mapActions } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputWysiwyg from "@/so-components/global/input/SOInputWysiwyg";
import resulter from "@/store/utils/resulter";
import { required } from "vuelidate/lib/validators";

export default {
    name: "WABlastTemplateCreate",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOInputRegular,
        SOInputWysiwyg,
    },
    data() {
        return {
            pageSetting: {
                title: "Buat template WA Blast",
            },
            nama: "",
        };
    },
    validations: {
        nama: {
            required,
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            blastType: "blastType",
            blastTypeId: "blastTypeId",
        }),
    },
    methods: {
        ...mapActions({
            createTemplateBlast: `${moduleName}/createTemplateBlast`,
            resetListTemplate: `${moduleName}/resetListTemplate`,
            setFetching: `${moduleName}/setFetching`,
        }),
        back() {
            if (this.blastType !== null) {
                this.$router.go(-2);
            }
            this.$router.back();
        },
        isValid() {
            let { nama } = this.$v;
            nama.$touch();

            return nama.$invalid;
        },
        saveTemplate(val) {
            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let payload = new FormData();
            payload.append("nama", this.nama);
            payload.append("template", val);
            if (this.blastType !== null) {
                payload.append("jenis", this.blastType)
                payload.append("idjenis", this.blastTypeId)
            }
            this.createTemplateBlast(payload)
                .then((response) => {
                    let { code, status, msg, data } = response.data;

                    if (status && code === 200) {
                        this.$toast.success(msg);
                        this.resetListTemplate();
                        this.$router.back();
                        this.setFetching(false);
                    } else {
                        this.setFetching(false);
                        this.setResponse(resulter.errorResult(msg));
                        this.$toast.error(msg);
                    }
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                    this.setResponse(resulter.errorResult(e));
                });
        },
    },
};
</script>
